import React, {Component} from 'react';
import toastr from "toastr";
import _ from 'lodash';
import {getCurrentUserId, getJwt} from '../../../services/authService';
import CampaignDetailsModal from "../../modals/CampaignDetailsModal";
import http from "../../../services/httpService";
import Theme from "../../../components/common/MuiTheme";

import {DateRangeInput} from "@blueprintjs/datetime";

import DateFnsUtils from '@date-io/date-fns';

import {paginate} from '../../utils/paginate_posts'

import {Menu, MenuItem, Tag, Spinner, Popover, Position, Tooltip, Button, Icon, Classes} from "@blueprintjs/core";
import {
    Cell, Column, CopyCellsMenuItem, SelectionModes, RenderMode, Table, Utils
} from "@blueprintjs/table";
import ItemsPerPage from '../../common/ItemsPerPage';
import Pagination from '../../common/Pagination';
import TableNoData from '../../common/TableNoData';
// import ReactGA from "react-ga";
import sizeMe from 'react-sizeme';
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import ChartLoader from "../../utils/chart-loader";
import InputRegular from "../../common/InputRegular";
import {Select} from "@blueprintjs/select";
import {number} from "prop-types";

/* Heights for every part of MultiPost post */
/* Spinner Components for loader in blueprint tables */

let spinnerComponent = <div style={{marginBottom: 7}}><Spinner size={15}/></div>
let horizontalClickedSpinner = <div
    style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
    <i className="fas fa-envelope-open" style={{color: '#18A9E3'}}></i>
    <div style={{marginLeft: 5}}><Spinner size={15}/></div>
    <div style={{marginLeft: 5}}><Spinner size={15}/></div>
</div>;

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class SMSCampaignPerformance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            posts: '',
            totalPosts: '',
            totalPages: '',
            totalCampaigns: 0,
            total_subscribers: 0,
            selectedSource: this.props.selectedSource,
            push_subscribers: [],
            pageSize: 10,
            currentPage: 1,
            lastPage: false,
            lastPageSize: '',
            paging: '',
            selectedAdAccount: '',
            sortColumn: {
                path: "updated_at", order: "asc"
            },
            spentFilter: 'greater than',
            loader: false,
            selectedCampaignPerformance: 'MESSAGES',
            preview: '',
            forceTableRerender: false,
            selectedSubType: '',
            selectedSubTypeFinished: '',
            selectedType: '',
            selectedTypeFinished: '',
            rowHeights: [100, 100, 100, 100, 100],
            tableColumnsWidth: [],
            minTableWidth: 500,
            lastColumnWidth: '',
            campaignDetailsModal: false,
            user: this.props.user,

            //filter data
            filterRecipient: '',
            filterStatus: 'All',
            filterSpent: 0,
            filterTimestamp: '',


            //datePicker
            startDate: null, //new Date(),
            endDate: null, //new Date(),
            //modal data

            campaignId: '',
            sendFrom: '',
            sendTime: {
                date: '', time: ''
            },
            message: '',
            segments: ['everything'],
            summary: {
                delivered: '',
                deliveredPercentage: '',
                notDelivered: '',
                notDeliveredPercentage: '',
                buffered: '',
                clicked: '',
            },
            sentFrom: '',
            analyticsItem: [],
            analyticsOpen: false,


            //markup data
            recipients: [{
                recipient: '+381603116443', status: 'Delivered', spent: '$8.00', timestamp: '22/12/2018', action: ''

            }, {
                recipient: '+381603116443', status: 'Sent', spent: '$8.00', timestamp: '22/12/2018', action: ''

            }, {
                recipient: '+381603116443', status: 'Unreachable', spent: '$8.00', timestamp: '22/12/2018', action: ''

            }, {
                recipient: '+381603116443', status: 'Delivered', spent: '$8.00', timestamp: '22/12/2018', action: ''

            }],
            statusValues: ['All', 'Delivered', 'Sent', 'Unreachable'],
            spentFilters: ['greater than', 'less than', 'greater or equal', 'less or equal', 'equal', 'not equal']
        }

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };


    }


    openModal = async (index) => {
        let item = this.state.posts[index]
        //console.log('index: ', index)
        //console.log('post: ', this.state.posts[index])

        let dateConverted = item.sent_at ? this.props.isodateToDate(item.sent_at) : ''
        let date = dateConverted ? dateConverted.substr(0, dateConverted.indexOf(' ')) : 'No date';
        let time = dateConverted ? dateConverted.substr(dateConverted.indexOf(' ') + 1) : 'No time';
        // let date = item ? item.sent_at_timezone ? item.sent_at_timezone.substr(0, item.sent_at_timezone.indexOf(' ')) : 'No date' : 'No date';
        // let time = item ? item.sent_at_timezone ? item.sent_at_timezone.substr(item.sent_at_timezone.indexOf(' ') + 1) : 'No time' : 'No time';

        let sent = item.sent_count
        let delivered = item.delivered_count
        let deliveredPercentage = ((delivered / sent) * 100).toFixed(2) + '%'
        let notDelivered = sent - delivered
        let notDeliveredPercentage = ((notDelivered / sent) * 100).toFixed(2) + '%'


        let newSendTime = {
            date: date, time: time
        }

        let newSummary = {
            delivered: delivered,
            deliveredPercentage: sent === 0 ? '0%' : deliveredPercentage,
            notDelivered: sent === 0 ? 0 : notDelivered,
            notDeliveredPercentage: sent === 0 ? '0%' : notDeliveredPercentage,
            buffered: '',
            clicked: ''
        }

        this.setState({
            campaignId: this.state.posts[index].id,
            message: this.state.posts[index].message,
            campaignDetailsModal: true,
            segments: this.state.posts[index].tags,
            sendTime: newSendTime,
            summary: newSummary,
            sentFrom: this.state.posts[index].from
        })
    }
    rowHover = async (element) => {
        // console.log('hovered element: ', element)
    }
    getPostsData = async () => {
        //console.log('sms - get post data')
        try {
            // this.setState({loader: false})
            await this.setState({loader: true})
            const pageSize = await this.state.pageSize;
            let selectedSubType = await this.props.selectedSubType;
            let selectedType = await this.props.selectedType;
            let selectedSource = await this.props.selectedSource;
            let userId = getCurrentUserId();
            // let selectedSource = '1160';

            // let apiCallType = await selectedSubType.name === 'Single Custom Links' ? selectedType.name === 'Show All' ? 'facebook_all_single_posts' :
            //     selectedType.name === 'Autopush' ? 'facebook_single_posts' : 'facebook_custom_posts' : selectedSubType.name === 'Multiple Custom Links' ?
            //     selectedType.name === 'Show All' ? 'facebook_all_multiple_posts' : selectedType.name === 'Autopush' ?
            //         'facebook_auto_multiple_posts' : 'facebook_custom_multiple_posts' : 'facebook_plain_text_posts';

            const result = await http.get('api/user/' + userId + '/project/' + selectedSource + '/sms/page_size/' + pageSize + '?page=' + this.state.currentPage, {headers: {authorization: getJwt()}});
            const data = await result.data;
            // console.log('sms data: ', result);
            //this.props.selectedSubType.name === 'Multiple Custom Links' ? [200,200,200,200,300,300,300,200,200,200] : [100,100,100,100,100,100,100,100,100,100],
            // let rowHeights = await this.props.selectedSubType.name === 'Multiple Custom Links' ?
            //     await data.posts.data.map( post => post.posts.length > 0 ?
            //         ( post.posts.length * multiPostSinglePostHeight) + multiPostGlobalPartHeight :
            //         multiPostGlobalPartHeight) :
            //     await this.props.selectedSubType.name === 'Single Custom Links' ?
            //         data.posts.map( () => 100) : data.posts.data.map( () => 100);
            await this.setState({
                selectedSource, // rowHeights,
                posts: this.state.selectedSubType === 'Campaigns' ? data.sms_texts.data : [],
                selectedSubType: selectedSubType.name,
                selectedType: selectedType.name,
                totalPosts: data.total_sms_s,
                totalPages: data.total_pages,
                lastPage: (data.total_pages < 1) || (this.state.currentPage === data.total_pages) ? true : false,
                lastPageSize: ((data.total_sms_s % this.state.pageSize) === 0) ? data.total_sms_s === 0 ? 0 : this.state.pageSize : ((data.total_sms_s % this.state.pageSize) < 0) ? data.total_sms_s : data.total_sms_s % this.state.pageSize,
                selectedSubTypeFinished: this.props.selectedSubType.name, // selectedTypeFinished: this.props.selectedType.name,
                loader: false
            })
            // console.log('zavrsio sam: ', this.state.loader, this.state.posts);
            //     this.state.lastPageSize : this.state.posts.length :
            //     this.state.pageSize === this.state.posts.length ? this.state.pageSize : this.state.posts.length)
            if (!this.state.posts) {
                this.setState({loader: false})
            }
            await this.setState({forceTableRerender: true})
            await this.setState({forceTableRerender: false})
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                // toastr.error("Something went wrong... Please refresh and try again.");
                this.setState({loader: false, posts: '', rowHeights: []})
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    }

    componentDidMount = async () => {
        //  ReactGA.pageview(window.location.pathname + window.location.search);


        try {
            await this.getPostsData()
        } catch (ex) {
            if (ex.response && ex.response.status === 404) toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }

        // this.getPreview();
    }


    componentDidUpdate = async () => {

        if (this.state.selectedSubType !== this.props.selectedSubType.name) {
            //console.log('entered CDU 1')

            this.setState({
                loader: true, currentPage: 1, selectedSubType: this.props.selectedSubType.name,
            })
            this.getPostsData();
        }

        if (this.state.selectedSource !== this.props.selectedSource) {
            // console.log('entered CDU 2')

            this.setState({
                loader: true, selectedSource: this.props.selectedSource
            })
            this.getPostsData();
        }

        // if (!this.state.posts && !this.state.loader) {
        //     // console.log('entered CDU 3')
        //
        //     this.recalculateColsWidth(1000)
        // }


        // this.getPreview();

        // if (this.state.selectedSource !== this.props.selectedSource) {
        //     // console.log('entered CDU 4')
        //
        //     this.handlePageChange(1, this.props.selectedSource, "all");
        //     this.getPostsData();
        //     this.setState({selectedSource: this.props.selectedSource})
        // }
        if (this.state.user !== this.props.user) {
            this.setState({
                user: this.props.user
            })
        }
    }

    openCampaignAnalytics = async (rowData, rowMeta) => {

        // console.log('rowData: ', rowData)
        // console.log('rowMeta: ', rowMeta)

        //console.info('row clicked')

        const item = this.state.posts[rowMeta.rowIndex]
        // console.log('analytics item: ', item)

        await this.setState({
            analyticsItem: item, analyticsOpen: true
        })

    }


    handleRowsPerPageChange = async (number) => {
        // console.log('handleRowsPerPageChange entered')
        let pageSize = await parseInt(number)
        // console.log('handleRowsPerPageChange - pageSize: ',)
        let userId = await this.props.user.id;
        let selectedSource = await this.props.selectedSource;
        if (pageSize !== 0) {
            await this.setState({pageSize, tableLoader: true});
            const result = await http.get('api/user/' + userId + '/project/' + selectedSource + '/sms/page_size/' + pageSize + '?page=' + 1, {headers: {authorization: getJwt()}});

            // console.log('handleRowsPerPageChange: ', result)

            await this.setState({
                posts: result.data.sms_texts.data,
                totalPages: result.data.total_pages,
                currentPage: 1,
                pageSize,
                tableLoader: false
            })
        }
    };

    handlePageChange = async (number) => {
        // console.log('handlePageChanged entered')

        let page = await parseInt(number)

        // console.log('page selected: ', page)

        let userId = await this.props.user.id;
        let selectedSource = await this.props.selectedSource;
        if ((page !== 0) && (page !== this.state.lastPage)) {

            await this.setState({currentPage: page, tableLoader: true});

            const result = await http.get('api/user/' + userId + '/project/' + selectedSource + '/sms/page_size/' + this.state.pageSize + '?page=' + page, {headers: {authorization: getJwt()}});

            // console.log('handlePageChange result: ', result)

            await this.setState({
                posts: result.data.sms_texts.data, totalPages: result.data.total_pages, tableLoader: false
            })
        }
    };

    handleChangeCampaignsNumberPerPage = async (value) => {
        await this.setState({
            currentPage: 1,
            pageSize: value,
            lastPage: value > this.state.totalPosts ? true : this.state.lastPage,
            lastPageSize: value > this.state.totalPosts ? this.state.totalPosts : this.state.lastPageSize,
            loader: true
        })

        await this.getPostsData()
    }

    getPreview = async () => {
        if (!this.state.preview) {
            try {
                const add_account_token = 'EAAZAfK9tK44IBADVZBY4gjXJZBqKdAdCqQokgs5uVNiWm9PtZA7L1qvMF6w2qmNcZCPZAfTfZCCtoxhfW0N3KJZBeRkXLMCfpKuq3SNu3Ybvl9R7JSJU337WcOZB4ZCeO2RyZCLBsBN7j5iDk8GyF2FhUAlbI6C6obOPLB2rCekBNYeGQZDZD';
                const add_account_id = 'act_269773933645768';
                const campaign = await this.state.campaigns[0] || {};
                const link = 'https://nba.com';
                let object_story_spec = {
                    "page_id": 106911734110630, "link_data": {
                        "call_to_action": {
                            "type": "USE_APP", "value": {
                                "link": link
                            }
                        },
                        "description": "Ovde ide opis",
                        "link": link,
                        "message": "Probna Poruka",
                        "name": "Ovde ide ime",
                        "picture": link
                    }
                }
                // const adsetId = await campaign.adsets.data[0].id || '';
                // const result = await http.get('https://graph.facebook.com/v4.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative={"type":27, "object_id": 112886416838535}&post={"link":"https://nba.com", "message":"Lorem ipsum dolor sit amet","picture":"http://url.to/your/custom/image.jpg","name":"Facebook","caption":"www.facebook.com","description":"Lorem ipsum dolor sit amet"}')
                const result = await http.get(facebook_app_marketing_url + add_account_id + '/generatepreviews?access_token=' + add_account_token + '&ad_format=MOBILE_FEED_STANDARD&creative={"object_story_spec": {"page_id": "106911734110630", "link_data": { "call_to_action": {"type": "LEARN_MORE", "value": { "link": "https://nba.com" } },"description": "Ovde ide opis", "link": "https://nba.com", "message": "Probna Poruka","name": "Ovde ide ime", "picture": "https://cdn.pixabay.com/photo/2015/12/01/20/28/road-1072823__340.jpg" }}}', {headers: {authorization: getJwt()}})

                // Ad formats: DESKTOP_FEED_STANDARD, FACEBOOK_STORY_MOBILE, INSTAGRAM_EXPLORE_CONTEXTUAL, INSTAGRAM_EXPLORE_IMMERSIVE, INSTAGRAM_STANDARD, INSTAGRAM_STORY, INSTANT_ARTICLE_RECIRCULATION_AD, INSTANT_ARTICLE_STANDARD, INSTREAM_VIDEO_DESKTOP, INSTREAM_VIDEO_MOBILE, MESSENGER_MOBILE_INBOX_MEDIA, MESSENGER_MOBILE_STORY_MEDIA, MOBILE_BANNER, MOBILE_FEED_BASIC, MOBILE_FEED_STANDARD, MOBILE_FULLWIDTH, MOBILE_INTERSTITIAL, MOBILE_MEDIUM_RECTANGLE, MOBILE_NATIVE, RIGHT_COLUMN_STANDARD, SUGGESTED_VIDEO_DESKTOP, SUGGESTED_VIDEO_MOBILE, WATCH_FEED_MOBILE"
                // const result = await http.get('https://graph.facebook.com/v5.0/' + add_account_id + '/generatepreviews?access_token=' + add_account_token +
                //     '&ad_format=MOBILE_FEED_STANDARD&creative=[{"object_story_spec": "' + object_story_spec + '"}]')


                const iframe = await result.data.data[0].body;
                await this.setState({preview: iframe})
            } catch (e) {
                //console.log('error: ', e)
            }
        }

    }


    getMuiTheme = () => createTheme({
        typography: {
            htmlFontSize: 11, fontFamily: 'Poppins', color: '#344A5E'
        }, overrides: {
            MuiPaper: {
                elevation4: {
                    boxShadow: 'none', border: '1px solid #D6DBDF'
                }
            }, MUIDataTableBodyCell: {
                root: {
                    fontWeight: 600
                    // backgroundColor: "blue"
                }
            }, MUIDataTableHeadCell: {
                root: {
                    fontWeight: 600
                    // backgroundColor: "blue"
                }
            }, MuiTableRow: {
                root: {
                    cursor: 'pointer', transition: '.3s', '&:nth-child(odd)': {
                        backgroundColor: '#FAFAFA'
                    }
                }, hover: {
                    "&:hover": {
                        backgroundColor: "rgba(38, 170, 225, 0.2) !important"
                    }
                }, // selected: {
                //     "&:hover": {
                //         backgroundColor: "#26AAE1 !important"
                //     }
                // }
            }, MuiIconButton: {
                label: {
                    // fontSize: 30
                    // color: "#344A5E"
                }
            }, MUIDataTableSelectCell: {
                fixedLeft: {
                    zIndex: 1
                }, root: {}, checkboxRoot: {
                    color: "#D6DBDF !important",
                }, checked: {
                    color: "#344A5E !important"
                },
            }, MUIDataTableToolbarSelect: {
                root: {
                    paddingTop: 5,
                    paddingBottom: 5,
                    paddingRight: 20,
                    paddingLeft: 20,
                    backgroundColor: '#fff',
                    boxShadow: 'none',
                    zIndex: 1
                }
            }, MuiTooltip: {
                tooltip: {
                    fontSize: 12,
                }
            }, MuiInput: {
                underline: {
                    "&:after": {
                        borderBottom: '2px solid #18A9E3'
                    }
                }
            }, MUIDataTableToolbar: {
                icon: {
                    "&:hover": {
                        color: '#18A9E3'
                    }
                }, iconActive: {
                    color: '#18A9E3'
                }
            }, MuiCheckbox: {
                colorPrimary: {
                    "&.Mui-checked": {
                        color: '#344A5E'
                    }
                }
            }, MuiChip: {
                root: {
                    borderRadius: 4
                }
            }, MuiButton: {
                textPrimary: {
                    color: '#18A9E3'
                }
            }
        }
    })


    statusItemRenderer = (item, {modifiers, handleClick}) => {
        //{console.log('item: ',item)}
        return (

            <MenuItem
                key={item}
                text={item === 'All' ? item : item === 'Delivered' ? <React.Fragment>
                    <img className='margin-right-5' src="/img/double-tick-indicator.png" alt="checked"/>
                    Delivered
                </React.Fragment> : item === 'Sent' ? <React.Fragment>
                    <img className='margin-right-5' src="/img/double-tick-indicator-grey.png"
                         alt="checked-grey"/>
                    Sent
                </React.Fragment> : <React.Fragment>
                    <img className='margin-right-5' src="/img/material-close-grey.png"
                         alt="unreachable"/>
                    Unreachable
                </React.Fragment>

                }
                value={item}
                active={modifiers.active}
                shouldDismissPopover={true}
                onClick={handleClick}
            />)
    };


    spentFilterItemRenderer = (item, {modifiers, handleClick}) => {
        //{console.log('item: ',item)}
        return (

            <MenuItem
                key={item}
                text={item}
                value={item}
                active={modifiers.active}
                shouldDismissPopover={true}
                onClick={handleClick}
            />)
    };
    statusItemSelect = async (item) => {
        await this.setState({
            filterStatus: item
        })
    }

    spentFilterItemSelect = async (item) => {
        await this.setState({
            spentFilter: item
        })
    }


    headerSortMenu = () => {
        const sortAsc = () => this.sortColumn(this.index, (a, b) => this.compare(a, b));
        const sortDesc = () => this.sortColumn(this.index, (a, b) => this.compare(b, a));
        return (<Menu>
            <MenuItem icon="sort-asc" onClick={sortAsc} text="Sort Rank Asc"/>
            <MenuItem icon="sort-desc" onClick={sortDesc} text="Sort Rank Desc"/>
        </Menu>);
    }


    updateTableWidth = (index, width) => {
        /* For table width to be rerendered forceRerenderOnSelectionChange in table props should be updated with
         forceTableRerender state change */
        let newTable = this.state.tableColumnsWidth;
        newTable[index] = width;
        this.setState({
            tableColumnsWidth: newTable, forceTableRerender: true
        })
        this.setState({
            forceTableRerender: false
        })
    }

    renderBodyContextMenu = (context) => {
        // console.log('Ovo je context: ', context)
        return (<Menu>
            <CopyCellsMenuItem context={context} getCellData={this.getCellData} text="Copy"/>
        </Menu>);
    };


    handleDate = (date) => {
        if (this.state.user.locals) {
            let dateFormat = this.state.user.locals.date_format
            let timeFormat = this.state.user.locals.time_format
            // console.log('dateFormat: ', dateFormat)
            // console.log('timeFormat: ', timeFormat)
            // console.log('date: ', date)

            let dateOutput = '';
            let timeOutput = '';
            let dateTimeOutput = '';

            //date formatting according to user settings
            const dateObj = date;
            const month = dateObj.getMonth() < 10 ? '0' + dateObj.getMonth() : dateObj.getMonth();
            const day = String(dateObj.getDate()).padStart(2, '0');
            const year = dateObj.getFullYear();

            switch (dateFormat) {
                case 'DD-MM-YYYY':
                    dateOutput = day + '-' + month + '-' + year;
                    break;
                case 'MM-DD-YYYY':
                    dateOutput = month + '-' + day + '-' + year
                    break;
                case 'YYYY-MM-DD':
                    dateOutput = year + '-' + month + '-' + day
                    break;
            }
            //console.log('dateOutput: ', dateOutput)

            //time formatting according to user settings

            let hours = date.getHours();
            let minutes = date.getMinutes();
            let ampm = hours >= 12 ? 'PM' : 'AM';

            minutes = minutes < 10 ? '0' + minutes : minutes;

            if (timeFormat === 'AM/PM') {
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                timeOutput = hours + ':' + minutes + ampm;
            } else {
                timeOutput = hours + ':' + minutes
            }

            dateTimeOutput = dateOutput + ' ' + timeOutput
            return dateTimeOutput
        } else {
            return date.toLocaleString()
        }

    }


    pageSizeItemRenderer = (item, {modifiers, handleClick}) => {
        //{console.log('item: ',item)}
        return (

            <MenuItem
                key={item.text}
                text={item.text}
                value={item.value}
                active={modifiers.active}
                shouldDismissPopover={true}
                onClick={handleClick}
            />)
    };
    handleDateChange = (e) => {
        // console.log('picked data: ', e)
        this.setState({
            selectedDate: e
        })
    }

    tableLoaderRenderer = () => {
        return <div className='table-loader-container panel-container'>
            <ChartLoader/>
        </div>
    }

    closeAnalytics = async () => {
        this.setState({
            analyticsOpen: false
        })
    }

    handleRangeChange = (dateRange) => {
        // console.log('range change: ', dateRange)

        let startDate = dateRange[0]
        // console.log('startDate: ', startDate)
        let endDate = dateRange[1]
        // console.log('endDate: ', endDate)

        this.setState({
            startDate: startDate, endDate: endDate
        })
    }


    applyFilter = () => {
        // console.log('apply filter')
    }
    rerunCampaign = async (e, campaign) => {
        e.stopPropagation()
        this.props.history.push('/new/sms', campaign)
    }

    render() {
        //console.log('entered render')
        if (document.querySelector('.bp3-table-cell')) {
            document.querySelector('.bp3-table-cell').addEventListener('mouseover', (e) => this.rowHover(e.target), false)
        }

        const tableOptions = {
            serverSide: true,
            print: false,
            count: this.state.totalPosts,
            search: false,
            download: false,
            filter: false,
            columns: false,
            viewColumns: false,
            selectableRows: 'none',
            onRowClick: this.openCampaignAnalytics,
            onChangeRowsPerPage: (number) => this.handleRowsPerPageChange(number),
            page: this.state.currentPage - 1,
            rowsPerPage: this.state.pageSize,
            rowsPerPageOptions: [10, 25, 50],
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        this.handlePageChange(tableState.page + 1);
                        break;
                    case 'sort':
                        this.sort(tableState.page, tableState.sortOrder);
                        break;
                }
            },

        }

        const tableColumns = [{
            name: process.env.REACT_APP_ENVIRONMENT === 'DEV' ? "total_count" : "sent_count", label: "Sent", options: {
                filter: false, sort: false, customBodyRender: (value) => {
                    return <div className='sent-cell-container'>
                        <i className="fas fa-paper-plane type-icon"
                           style={{marginBottom: 5, marginLeft: 0}}></i>
                        <span className='text-bold blue-text'>{value}</span>
                    </div>

                }
            }
        },

            {
                name: "delivered_count", label: "Delivered", options: {
                    filter: false, sort: false, customBodyRender: (value) => {
                        return <div className='sent-cell-container'>
                            <img style={{marginRight: 5}} src='/img/double-tick-indicator.png' alt='double tick'/>
                            {value}
                        </div>

                    }
                }

            }, {
                name: "delivered_count", label: "%", options: {
                    filter: false, sort: false, customBodyRender: (value, tableMeta, updateValue) => {
                        return <div className='sent-cell-container'>
                                <span
                                    className='grey-text'>{this.state.posts[tableMeta.rowIndex].sent_count === 0 ? '-' : this.state.posts[tableMeta.rowIndex].delivered_count === 0 ? '0%' : Math.round((this.state.posts[tableMeta.rowIndex].delivered_count / this.state.posts[tableMeta.rowIndex].sent_count) * 100) + '%'}</span>
                        </div>

                    }
                }
            }, {
                name: "spent", label: "Spent", options: {
                    filter: false, sort: false, customBodyRender: (value, tableMeta, updateValue) => {
                        //console.log('value: ', value)
                        return <div className='sent-cell-container'>
                                <span>{!value.includes('$') ? Number(value.replace('$', '')).toFixed(2) : '$' + Number(value.replace('$', '')).toFixed(2)}
                                </span>
                        </div>

                    }
                }
            }, {
                name: "message", label: "Message", options: {
                    filter: false, sort: false,
                }
            }, {
                name: "tags", label: "Segments", options: {
                    filter: false, sort: false, customBodyRender: (value, tableMeta, updateValue) => {


                        return value.length ? value.length < 3 ? value.map(tag =>

                            <Tag key={tag} className='custom-tag'>
                                {tag.toLowerCase()}
                            </Tag>) : <Tooltip
                            className='tags-tooltip'
                            content={<div className='remaining-tags'>
                                {value.map(tag => <Tag className='custom-tag'>
                                    {tag.toLowerCase()}
                                </Tag>)}
                            </div>}
                            position={Position.TOP}>
                            <div className="remaining-tags-container">
                                {value.length}
                            </div>
                        </Tooltip> : ''

                    }
                }
            }, {
                name: "sent_at_timezone", label: "Sent at", options: {
                    filter: false, sort: false, customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];
                        // console.log('date check: ', this.props.isodateToDate(item.created_at))
                        let dateConverted = item.sent_at ? this.props.isodateToDate(item.sent_at) : ''
                        let date = dateConverted ? dateConverted.substr(0, dateConverted.indexOf(' ')) : 'No date';
                        let time = dateConverted ? dateConverted.substr(dateConverted.indexOf(' ') + 1) : 'No time';

                        return <div className='min-width-130'>
                            {dateConverted}
                        </div>

                    }
                }
            }, {
                name: "sent_at_timezone", label: "Actions", options: {
                    filter: false, sort: false, customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.posts[tableMeta.rowIndex];

                        //console.info('item: ', item)
                        return (

                            <div className='text-center'>
                                <Tooltip

                                    position={Position.TOP}
                                    className={Classes.TOOLTIP_INDICATOR}
                                    content={<span>Create new campaign with the same data</span>}
                                    isOpen={this.state.isOpen}
                                >
                                    <Icon className='rerun-icon' onClick={(e) => this.rerunCampaign(e, item)}
                                          icon='duplicate'/>
                                </Tooltip>
                            </div>

                        )

                    }
                }
            },

        ]
        const {
            pageSize, currentPage, sortColumn, searchQuery, sub_type, type_of_subscription, total_subscribers
        } = this.state;
        let {
            subscribers: subscribersAll, //push_subscribers: subscribersPush
        } = this.state;


        let filtered = subscribersAll;
        if (searchQuery) {
            if (sub_type) {
                filtered = subscribersAll.filter(m => m.subscriber_name.toLowerCase().includes(searchQuery.toLowerCase()));
            }
        }
        const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

        const totalSent = process.env.REACT_APP_ENVIRONMENT === 'DEV' ? this.state.analyticsItem.total_count : this.state.analyticsItem.sent_count
        const sentCount = this.state.analyticsItem.sent_count
        const delivered = this.state.analyticsItem.delivered_count
        const buffered = this.state.analyticsItem.buffered_count
        let bufferedPercentage = buffered === 0 ? '(0%)' : (this.state.analyticsItem.buffered_count / this.state.analyticsItem.sent_count * 100) % 1 === 0 ? //'(' +
            (this.state.analyticsItem.buffered_count / this.state.analyticsItem.sent_count * 100)
            //+ '%)'
            : //'(' +
            Math.round(this.state.analyticsItem.buffered_count / this.state.analyticsItem.sent_count * 100).toFixed(2)
        //+ '%)'
        if (bufferedPercentage !== '(0%)') {

            if (bufferedPercentage % 1 === 0) {
                bufferedPercentage = '(' + Number(bufferedPercentage).toFixed(0) + '%)'
            } else {
                bufferedPercentage = '(' + Number(bufferedPercentage) + '%)'
            }
        }

        //console.log('buffered percentage: ', (this.state.analyticsItem.buffered_count / this.state.analyticsItem.sent_count * 100))

        let deliveredPercentage = delivered === 0 ? '(0%)' : (this.state.analyticsItem.delivered_count / this.state.analyticsItem.sent_count * 100) % 1 === 0 ?

            //'(' +
            this.state.analyticsItem.delivered_count / this.state.analyticsItem.sent_count * 100
            //+ '%)'
            : //'(' +
            Math.round(this.state.analyticsItem.delivered_count / this.state.analyticsItem.sent_count * 100).toFixed(2)
        //+ '%)'
        if (deliveredPercentage !== '(0%)') {
            if (deliveredPercentage % 1 === 0) {
                deliveredPercentage = '(' + Number(deliveredPercentage).toFixed(0) + '%)'
            } else {
                deliveredPercentage = '(' + Number(deliveredPercentage) + '%)'
            }
        }
        //console.log('deliveryPercentage: ', deliveredPercentage)

        const notDelivered = this.state.analyticsItem.undelivered_count


        let notDeliveredPercentage = notDelivered === 0 ? '(0%)' : this.state.analyticsItem.undelivered_count / this.state.analyticsItem.sent_count * 100 % 1 === 0 ? //'(' +
            (this.state.analyticsItem.undelivered_count / this.state.analyticsItem.sent_count * 100)
            //+ '%)'
            : //'(' +
            Math.round((this.state.analyticsItem.undelivered_count) / this.state.analyticsItem.sent_count * 100).toFixed(2)
        //+ '%)'
        if (notDeliveredPercentage !== '(0%)') {
            if (notDeliveredPercentage % 1 === 0) {
                notDeliveredPercentage = '(' + Number(notDeliveredPercentage).toFixed(0) + '%)'
            } else {
                notDeliveredPercentage = '(' + Number(notDeliveredPercentage) + '%)'
            }
        }

        const tableCampaigns = this.state.posts;

        const recipientTableColumns = [{
            name: "recipient", label: "Recipient", options: {
                filter: false, sort: false,

            }
        }, {
            name: "status", label: "Status", options: {
                filter: false, sort: false, customBodyRender: (value) => {
                    return value === 'All' ? value : value === 'Delivered' ? <React.Fragment>
                        <img className='margin-right-5' src="/img/double-tick-indicator.png"
                             alt="checked"/>
                        Delivered
                    </React.Fragment> : value === 'Sent' ? <React.Fragment>
                        <img className='margin-right-5'
                             src="/img/double-tick-indicator-grey.png"
                             alt="checked-grey"/>
                        Sent
                    </React.Fragment> : <React.Fragment>
                        <img className='margin-right-5' src="/img/material-close-grey.png"
                             alt="unreachable"/>
                        Unreachable
                    </React.Fragment>

                }

            }

        }, {
            name: "spent", label: "Spent", options: {
                filter: false, sort: false,

            }
        }, {
            name: "timestamp", label: "Timestamp", options: {
                filter: false, sort: false,

            }
        }, // {
            //     name: "timestamp",
            //     label: "Action",
            //     options:
            //         {
            //             filter: false,
            //             sort: false,
            //
            //         }
            // },

        ]


        const recipientTableOptions = {
            serverSide: true,
            print: false,
            count: this.state.totalPosts,
            search: false,
            download: false,
            filter: false,
            columns: false,
            viewColumns: false,
            selectableRows: 'none',
            onRowClick: this.openCampaignAnalytics,
            onChangeRowsPerPage: (number) => this.handleRowsPerPageChange(number),
            page: this.state.currentPage - 1,
            rowsPerPage: this.state.pageSize,
            rowsPerPageOptions: [10, 25, 50],
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        this.handlePageChange(tableState.page + 1);
                        break;
                    case 'sort':
                        this.sort(tableState.page, tableState.sortOrder);
                        break;
                }
            },

        }

        //console.log('tableCampaigns: ', tableCampaigns)

        return (

            <React.Fragment>
                <div
                    className="d-block margin-top-20"> {/*{ this.state.preview ? <div dangerouslySetInnerHTML={{ __html: this.state.preview }} /> : null }*/}

                    {this.state.analyticsOpen ? <React.Fragment>
                            <div className='sms-analytics-container'>

                                <div className="analytics-title">
                                    <span onClick={this.closeAnalytics}>{'< Campaign Details'}</span>
                                </div>
                                <div className="sms-analytics-main">
                                    <div className="top-part-container">
                                        <div className="top-part-info">
                                            <div className='display-flex'>
                                                <p className='text-semi-bold'>Spent</p>
                                                <p>{!this.state.analyticsItem.spent.includes('$') ? Number(this.state.analyticsItem.spent.replace('$', '')).toFixed(2) : '$' + Number(this.state.analyticsItem.spent.replace('$', '')).toFixed(2)}</p>
                                            </div>
                                            <div className='display-flex'>
                                                <p className='text-semi-bold'>Sender</p>
                                                <p>{this.state.analyticsItem.from}</p>
                                            </div>
                                            <div className='display-flex'>
                                                <p className='text-semi-bold'>Created at</p>
                                                <p>{this.props.isodateToDate(this.state.analyticsItem.sent_at)}</p>
                                            </div>
                                        </div>
                                        <div id='message' className='display-flex sms-message-part'>
                                            <p className='text-semi-bold'>Message</p>
                                            <p className='message-text'>{' ' + this.state.analyticsItem.message}</p>
                                        </div>
                                    </div>
                                    <div className='display-flex align-items-center'>
                                        <p className='text-semi-bold'>Segments</p>
                                        <p>
                                            {this.state.analyticsItem.tags ? this.state.analyticsItem.tags.map(tag => <Tag
                                                className={['custom-tag', tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.toLowerCase() === 'daily' ? 'bp3-intent-success' : tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' : tag.toLowerCase() === 'weekly' ? 'bp3-intent-darkblue' : '']}
                                                key={tag}
                                            >
                                                {tag}
                                            </Tag>) : ''}
                                        </p>
                                    </div>
                                    <div className='display-flex align-items-center'>
                                        <p className='text-semi-bold'>Summary</p>

                                        {process.env.REACT_APP_ENVIRONMENT === 'DEV' ?
                                            <p className='display-flex justify-content-start summary-data'>

                                                <p id='total' className='summary-segment'>
                                                    <i className="fas fa-paper-plane"></i>
                                                    <span className='summary-label'>Total:</span>

                                                    <span className='segment-number'>
                                                        {totalSent}
                                                    </span>
                                                </p>
                                                <p id='total' className='summary-segment'>
                                                    <i className="fas fa-paper-plane"></i>
                                                    <span className='summary-label'>Sent:</span>

                                                    <span className='segment-number'>
                                                        {sentCount}
                                                    </span>
                                                </p>
                                                <div className='display-flex campaign-info'>
                                                    <p id='delivered' className='summary-segment'>
                                                        <img src="/img/double-tick-indicator.png" alt="Delivered"/>
                                                        <span className='summary-label'>Delivered:</span>

                                                        <span className='segment-number'>{delivered}<span
                                                            className='grey-text'> {deliveredPercentage}</span>
                                                        </span>
                                                    </p>

                                                    <p id='not-delivered' className='summary-segment'>
                                                        <img src="/img/material-close.png" alt="Not delivered"/>
                                                        <span className='summary-label'>Not Delivered:</span>
                                                        <span
                                                            className='segment-number'>{notDelivered < 0 ? 0 : notDelivered}<span
                                                            className='grey-text'> {notDelivered < 0 ? '0%' : notDeliveredPercentage}</span>
                                                        </span>
                                                    </p>

                                                    <p id='buffered' className='summary-segment'>
                                                        <img src="/img/feather-loader.png" alt="Buffered"/>

                                                        <span className='summary-label'>Buffered:</span>
                                                        <span className='segment-number'>{buffered}<span
                                                            className='grey-text'> {bufferedPercentage}</span></span>
                                                    </p>
                                                </div>
                                                {/*<p id='clicked' className='summary-segment'>*/}
                                                {/*    <img src="/img/click.png" alt="Clicked"/>*/}

                                                {/*    <span className='summary-label'>Clicked:</span>*/}
                                                {/*    <span>{clicked}<span*/}
                                                {/*        className='grey-text'> {clickedPercentage}</span></span>*/}
                                                {/*</p>*/}

                                            </p> :

                                            <p className='display-flex justify-content-start summary-data'>

                                                <p id='total' className='summary-segment'>
                                                    <i className="fas fa-paper-plane"></i>
                                                    <span className='summary-label'>Total:</span>

                                                    <span className='segment-number'>
                                                        {totalSent}
                                                    </span>
                                                </p>

                                                <div className='display-flex campaign-info'>
                                                    <p id='delivered' className='summary-segment'>
                                                        <img src="/img/double-tick-indicator.png" alt="Delivered"/>
                                                        <span className='summary-label'>Delivered:</span>

                                                        <span className='segment-number'>{delivered}<span
                                                            className='grey-text'> {deliveredPercentage}</span>
                                                        </span>
                                                    </p>

                                                    <p id='not-delivered' className='summary-segment'>
                                                        <img src="/img/material-close.png" alt="Not delivered"/>
                                                        <span className='summary-label'>Not Delivered:</span>
                                                        <span
                                                            className='segment-number'>{notDelivered < 0 ? 0 : notDelivered}<span
                                                            className='grey-text'> {notDelivered < 0 ? '0%' : notDeliveredPercentage}</span>
                                                        </span>
                                                    </p>

                                                    <p id='buffered' className='summary-segment'>
                                                        <img src="/img/feather-loader.png" alt="Buffered"/>

                                                        <span className='summary-label'>Buffered:</span>
                                                        <span className='segment-number'>{buffered}<span
                                                            className='grey-text'> {bufferedPercentage}</span></span>
                                                    </p>
                                                </div>
                                                {/*<p id='clicked' className='summary-segment'>*/}
                                                {/*    <img src="/img/click.png" alt="Clicked"/>*/}

                                                {/*    <span className='summary-label'>Clicked:</span>*/}
                                                {/*    <span>{clicked}<span*/}
                                                {/*        className='grey-text'> {clickedPercentage}</span></span>*/}
                                                {/*</p>*/}

                                            </p>

                                        }


                                    </div>
                                </div>

                                {process.env.REACT_APP_ENVIRONMENT === 'DEV' ? <React.Fragment>
                                    <div className="filtering-row display-flex flex-wrap">
                                        <div className="filter-input">
                                            <InputRegular
                                                id="1"
                                                label1="Recipient"
                                                label2=""
                                                placeholder="Enter number"
                                                type='text'
                                                onChange={p => this.setState({
                                                    filterRecipient: p
                                                })}
                                                value={this.state.filterRecipient}
                                                // updateErrorsList={this.updateErrorsList}
                                                // errorMessage="Check your password"
                                                //fieldsCheckActive={this.state.fieldsCheckActive}
                                                required={false}
                                            />
                                        </div>
                                        <div id='select-status' className="filter-input">
                                            <label>Status</label>
                                            <Select
                                                items={this.state.statusValues}
                                                itemRenderer={this.statusItemRenderer}
                                                onItemSelect={this.statusItemSelect}
                                                filterable={false}
                                            >
                                                <Button text={this.state.filterStatus}
                                                        rightIcon="caret-down"></Button>

                                            </Select>
                                        </div>
                                        <div className='spent-container display-flex justify-content-space'>
                                            <div id='select-spent-filter'>
                                                <label>spent Relation</label>
                                                <Select
                                                    items={this.state.spentFilters}
                                                    itemRenderer={this.spentFilterItemRenderer}
                                                    onItemSelect={this.spentFilterItemSelect}
                                                    filterable={false}
                                                >
                                                    <Button text={this.state.spentFilter}
                                                            rightIcon="caret-down"></Button>

                                                </Select>
                                            </div>
                                            <div id='spentFilterInput' className="filter-input">
                                                <span>$</span>
                                                <InputRegular
                                                    id="3"
                                                    label1="Spent"
                                                    label2=""
                                                    placeholder="0.00"
                                                    type='number'
                                                    step='0.01'
                                                    min='0'
                                                    onChange={p => {
                                                        //p = p.substring(2)
                                                        //p = p.toFixed(2)
                                                        this.setState({
                                                            filterSpent: p
                                                        })
                                                    }}
                                                    value={Number(this.state.filterSpent)}
                                                    // updateErrorsList={this.updateErrorsList}
                                                    // errorMessage="Check your password"
                                                    //fieldsCheckActive={this.state.fieldsCheckActive}
                                                    required={false}
                                                />
                                            </div>
                                        </div>
                                        <div id='datepicker' className="filter-input">
                                            <label>Timestamp</label>
                                            <DateRangeInput
                                                formatDate={date => this.handleDate(date)}
                                                onChange={this.handleRangeChange}
                                                parseDate={str => new Date(str)}
                                                value={[this.state.startDate, this.state.endDate]}
                                                allowSingleDayRange={true}
                                                timePickerProps={{
                                                    autoFocus: true
                                                }}
                                            />
                                        </div>
                                        <button className='btn-action'
                                                onClick={this.applyFilter}
                                        >Apply Filter
                                        </button>
                                    </div>
                                    <MuiThemeProvider theme={this.getMuiTheme()}>
                                        <MUIDataTable
                                            title={""}
                                            data={this.state.recipients}
                                            columns={recipientTableColumns}
                                            options={recipientTableOptions}
                                        />
                                    </MuiThemeProvider>
                                </React.Fragment> : ''}
                            </div>


                        </React.Fragment> :

                        tableCampaigns ?

                            this.state.tableLoader ? this.tableLoaderRenderer() : this.state.posts.length !== 0 ?
                                <React.Fragment>
                                    <MuiThemeProvider theme={this.getMuiTheme()}>
                                        <MUIDataTable
                                            title={""}
                                            data={this.state.posts}
                                            columns={tableColumns}
                                            options={tableOptions}
                                        />
                                    </MuiThemeProvider>
                                </React.Fragment> :
                                <div className='no-contacts-container panel-container margin-top-20'>

                                    <img src="/img/emptyStates/url_shortener_my_campaigns.gif"
                                         alt="no SMS"/>
                                    <h3>There is no data for this type of messages.</h3>
                                    <div className='flex-direction-row justify-content-center'>
                                        <button id='tags_btn' data-target="#tagModal"
                                                onClick={(e) => this.props.history.push('/new/sms')}
                                                className='btn-action margin-bottom-10'>
                                            Start an SMS campaign
                                        </button>
                                    </div>
                                </div>

                            : this.tableLoaderRenderer()}
                </div>

                {/*{ console.log(this.state.currentPage, this.state.totalPosts, this.state.totalPages, this.state.lastPageSize, this.state.lastPage)}*/}
                <CampaignDetailsModal
                    showModal={this.state.campaignDetailsModal}
                    handleClose={() => this.setState({campaignDetailsModal: false})}
                    maxWidth={540}
                    history={this.props.history}
                    campaignId={this.state.campaignId}
                    sendFrom={this.state.sendFrom}
                    sendTime={this.state.sendTime}
                    message={this.state.message}
                    segments={this.state.segments}
                    summary={this.state.summary}
                    sentFrom={this.state.sentFrom}
                />
            </React.Fragment>)
    }

}

export default sizeMe()

(SMSCampaignPerformance);